var BarChart = (function($) {

  var _s = {
    container: '.chm-block-bar-chart',
    barContainer: '.bar-container',
    bar: '.bar',
    barValue: '.bar-value'
  };

  var _init = function() {
    _bindEvents();
  };

  var _bindEvents = function() {

    $(window).on("scroll", function () {
      let pos = $(this).scrollTop();

      $(_s.barContainer).each(function() {
        let animateTriggerPos = $(this).offset().top - ($(window).outerHeight() / 2);
        
        let bar = $(this).find(_s.bar);
        let barValue = $(this).find(_s.barValue);
        let size = parseFloat(bar.attr('data-size'));
        size = size * 400; // 400px is max height of bar

        if ( pos > animateTriggerPos && !$(this).hasClass('js-animateComplete') ) {

          bar.each(function() {
            anime({
              targets: this,
              height: ['16px', size],
              duration: 1400,
              easing: 'easeOutCubic'
            });

          });

          barValue.each(function() {
            let barValueNum_el = $(this).find('.js-barValueNum');
            let barValueNum = parseInt(barValueNum_el.html());
            barValueNum_el.html(0);

            let anim = new countUp.CountUp(barValueNum_el[0], barValueNum, {
              duration:2,
            });
            anim.start();
          });

          $(this).addClass('js-animateComplete');
        }

      });
      

    });
    

  };

  return {
    init: _init
  };

})(jQuery);